/* eslint-disable jsx-a11y/alt-text */
import Navbar from "react-bootstrap/Navbar";
import { Nav, Button, Container, Dropdown, Overlay, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import Link from "next/link";
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { handleFavouriteLish } from "../../store/actions/favouriteAction";
import Script from 'next/script';
import { useSession, signIn, signOut } from "next-auth/react"

// import { Dropdown, Overlay, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";

const Header = () => {
  const auth = useSelector((state) => state.auth);
  const { isLoggedIn } = auth;

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  // console.log(isLoggedIn);
  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  // const favoriteInfo = [];
  const dispatch = useDispatch();
  // if (isLoggedIn) {
  useEffect(() => {
    dispatch(handleFavouriteLish());
  }, [dispatch]);
  // const size = FunWindowSize();
  const favoriteInfo = useSelector((state) => state?.favouriteInfo.favouriteInfo.data);
  const { data: session } = useSession()
  return (
    <>
      <Script strategy="lazyOnload" src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID | 'G-Q2GTQ1SQ7K'}`} id='NEXT_PUBLIC_GA_MEASUREMENT_ID' />

      <Script strategy="lazyOnload" id='NEXT_PUBLIC_GA_MEASUREMENT_ID'>
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID | 'G-Q2GTQ1SQ7K'}', {
            page_path: window.location.pathname,
            });
        `}
      </Script>



      <Navbar expand="lg" className="navbarCustom">
        <Container className="header-container">
          <Navbar.Brand href="/">
            <span className="desktop-logo">
              <Image src="/assets/images/logo.png" width={231} height={52} />
            </span>
            <span className="mobile-logo">
              <Image
                src="/assets/images/mobile-logo.png"
                width={53}
                height={52}
              />
            </span>
          </Navbar.Brand>
          <div className="NavbarRightBx">
            <Navbar.Collapse id="navbarScroll" className="mobmanuhide"  >
              <Nav className="navUl">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/aboutus">A propos</Nav.Link>
                <Nav.Link href="/faq">Faq</Nav.Link>
                {/* <Nav.Link href="/terms-conditions">Terms & Conditions</Nav.Link>
                <Nav.Link href="/privacy-policy">privacy Policy</Nav.Link> */}
                {/* <Nav.Link href="/contactus">Nous contacter</Nav.Link> */}
              </Nav>
            </Navbar.Collapse>
            <div className="profile-btn">
              {isLoggedIn && (<div className="dropdown" >
                <button className="dropbtn profile-btn" style={{ borderRadius: "999px" }}>PROFIL</button>
                <div className="dropdown-content">
                  <Nav.Link href="/profile">PROFIL</Nav.Link>
                  <Nav.Link href='/changepassword'>CHANGE PASSWORD</Nav.Link>
                </div>
              </div>)}
            </div>
            <div className="comment-btn-w">
              <span className="btn comment-btn" href="/contactus">
                <Nav.Link href="/contactus"> <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 10C19.0034 11.3199 18.6951 12.6219 18.1 13.8C17.3944 15.2117 16.3098 16.3992 14.9674 17.2293C13.6251 18.0594 12.0782 18.4994 10.5 18.5C9.18013 18.5034 7.87812 18.1951 6.7 17.6L1 19.5L2.9 13.8C2.30493 12.6219 1.99656 11.3199 2 10C2.00061 8.42176 2.44061 6.87485 3.27072 5.53255C4.10083 4.19025 5.28825 3.10557 6.7 2.4C7.87812 1.80493 9.18013 1.49656 10.5 1.5H11C13.0843 1.61499 15.053 2.49476 16.5291 3.97086C18.0052 5.44695 18.885 7.41565 19 9.5V10Z" stroke="#234270" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                </Nav.Link>
              </span>
            </div>
            <div className="favarite-btn">
              {isLoggedIn && <div ref={ref}>
                {/* <Button onClick={handleClick}>Holy guacamole!</Button> */}
                {/* <span className="btn btn-feather-star" onClick={handleClick}></span> */}
                <span className="btn btn-favarite-start" onClick={handleClick}><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 1L14.09 7.26L21 8.27L16 13.14L17.18 20.02L11 16.77L4.82 20.02L6 13.14L1 8.27L7.91 7.26L11 1Z" stroke="#234270" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                </span>
                <Overlay
                  show={show}
                  target={target}
                  placement="bottom"
                  container={ref}
                  containerPadding={20}
                >
                  <Popover id="popover-contained">
                    <Popover.Header as="h3">Favoris</Popover.Header>
                    <> {favoriteInfo && favoriteInfo.length > 0 ? favoriteInfo.map((item, index) => (
                      <span key={index}>
                        <Popover.Body>
                          <strong>{item.name}</strong> {item.sub_title}.
                        </Popover.Body>
                      </span>
                    ))
                      : null}</>
                  </Popover>
                </Overlay>
              </div>}
            </div>

            <Nav className="rightNav">
              {(session && session.user.email) ? (
                <button onClick={(e) => signOut(console.log(e))} key={1}>
                  <a className="nav-link">Déconnexion</a>
                </button >
              ) : isLoggedIn && (
                <Link href="/logout" key={1}>
                  <a className="nav-link">Déconnexion</a>
                </Link>
              )}

              {/* {isLoggedIn && (
                <Link href="/logout" key={1}>
                  <a className="nav-link">Déconnexion</a>
                </Link>
              )} */}

              {!isLoggedIn && (
                <>
                  <Link href="/login" key={2}>
                    <a className="nav-link">Se connecter</a>
                  </Link>
                  <Link href="/register" key={3}>
                    <a className="h-signupBtn">{`S'inscrire`}</a>
                  </Link>
                </>
              )}
            </Nav>
            <Navbar.Toggle />

          </div>

          <div className="mob_menu_opt">
            <Nav className="navUl">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/aboutus">A propos</Nav.Link>
              <Nav.Link href="/faq">Faq</Nav.Link>
              {/* <Nav.Link href="/terms-conditions">Terms & Conditions</Nav.Link>
              <Nav.Link href="/privacy-policy">Privacy Policy</Nav.Link> */}
              {/* <Nav.Link href="/contactus">Nous contacter</Nav.Link> */}
            </Nav>
          </div>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
